import React, { useState } from 'react';
import useLazyQuery from '../../../../../../../users/hooks/useLazyQuery'; // Use from users because other params (to be fixed)

import linkIcon from '../../../../../../assets/img/link-horizontal.svg';

import styles from './BasicSettings.module.css';

import Dropdown from '../../../Dropdown/Dropdown';
import NumberInputRow from '../NumberInputRow/NumberInputRow';

import {
  licenceTypes,
  recordActionPopups
} from '../../../../helpers/constants';

import {
  eurosToCredits,
  creditsToEuros
} from '../../../../helpers/creditsConversion/creditsConversion';

import {
  GET_INVITATION_LINK,
  GET_CLIENT_ACCOUNTS_TO_INVITE
} from '../../../../../../graphql/AccountManagement';
import CreditsManipulator from './components/CreditsManipulator';

export default ({
  level,
  subtitle1,
  subtitle2,
  label1,
  inviteText,
  internalRecord,
  setInternalRecord,
  activePopup,
  invitationParent,
  invitationType,
  parentWithLicence,
  defaultConstants
}) => {
  const [linkCopied, setLinkCopied] = useState(false);
  const [invitationLink, setInvitationLink] = useState(null);

  const isEditing =
    activePopup &&
    activePopup.type &&
    activePopup.type === recordActionPopups.EDIT;

  const showAdditionalBudget =
    internalRecord &&
    internalRecord.licence &&
    internalRecord.licence === licenceTypes.UNLIMITED;

  const getInvitationLink = useLazyQuery(GET_INVITATION_LINK, {
    fetchPolicy: 'no-cache'
  });

  const getClientAccountsToInvite = useLazyQuery(
    GET_CLIENT_ACCOUNTS_TO_INVITE,
    {
      fetchPolicy: 'no-cache'
    }
  );

  const copyLinkToClipboard = () => {
    if (invitationLink) {
      const dummy = document.createElement('input');
      // dummy.style.display = 'none';
      document.body.appendChild(dummy);

      dummy.setAttribute('id', 'goalurl');
      document.getElementById('goalurl').value = invitationLink;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    }
  };

  const onSelectClientCompleted = record => {
    let newMembers = [];

    if (
      internalRecord &&
      internalRecord.managers &&
      internalRecord.managers.length
    ) {
      newMembers = [...internalRecord.managers];
    }

    if (
      !internalRecord.managers ||
      !internalRecord.managers.some(mng => mng.id === record.value)
    ) {
      // Check if already selected
      const newRecord = {
        id: record.value,
        email: record.label
      };

      setInternalRecord({
        ...internalRecord,
        managers: [...newMembers, newRecord]
      });
    } else {
      const filteredSelectedRecords = internalRecord.managers.filter(
        mng => mng.id !== record.value
      );

      setInternalRecord({
        ...internalRecord,
        managers: filteredSelectedRecords
      });
    }
  };

  const fetchClientOptions = async (page, search) => {
    const clientsToInvite = await getClientAccountsToInvite({
      variables: {
        start: 0,
        end: (page + 1) * 10,
        search
      }
    });

    if (
      clientsToInvite &&
      clientsToInvite.data &&
      clientsToInvite.data.getClientAccountsToInvite &&
      clientsToInvite.data.getClientAccountsToInvite.clients &&
      clientsToInvite.data.getClientAccountsToInvite.clients.length
    ) {
      return clientsToInvite.data.getClientAccountsToInvite.clients.map(c => ({
        label: c.email,
        value: c.id
      }));
    }
    return [];
  };

  return (
    <div className={styles.content}>
      {subtitle1 ? (
        <>
          <div className={styles.subtitle}>{subtitle1}</div>
          <input
            className={styles.input}
            placeholder="Enter name"
            value={
              internalRecord && internalRecord.name ? internalRecord.name : ''
            }
            onChange={e =>
              setInternalRecord({
                ...internalRecord,
                name: e.target.value
              })
            }
          />
        </>
      ) : null}

      {level === 1 ? (
        <>
          <div className={styles.dropdownLicenceTopContainer}>
            <div
              className={`${styles.dropdownContainer} ${
                styles.dropdownLicenceContainer
              }`}
            >
              <div className={styles.subtitle}>License</div>
              <Dropdown
                customPlaceholder="Select licence"
                onSelectCompleted={licence => {
                  const newInternalRecord = { ...internalRecord };
                  if (licence && newInternalRecord.licence !== licence) {
                    newInternalRecord.licence = licence.value;
                    newInternalRecord.creditsAllocated =
                      defaultConstants.accountManagementLicenceCreditsMapping[
                        licence.value
                      ];
                    newInternalRecord.creditsLeft =
                      defaultConstants.accountManagementLicenceCreditsMapping[
                        licence.value
                      ];
                    newInternalRecord.permissions = {
                      ...newInternalRecord.permissions,
                      surveysIncludedInLicense:
                        (defaultConstants.accountManagementSurveysIncludedInLicencePermissionValues &&
                          defaultConstants
                            .accountManagementSurveysIncludedInLicencePermissionValues[
                            licence.value
                          ]) ||
                        0
                    };

                    if (newInternalRecord.licence === null) {
                      newInternalRecord.nextLicence = null;
                    }
                  }

                  setInternalRecord(newInternalRecord);
                }}
                fetchOptions={() => {
                  const licenceOptions = Object.keys(licenceTypes).map(l => {
                    const capitalised = `${l[0].toUpperCase()}${l
                      .slice(1)
                      .toLowerCase()}`;
                    return {
                      value: l,
                      label: capitalised.replaceAll('_', ' ')
                    };
                  });

                  return [
                    {
                      value: null,
                      label: 'No license'
                    },
                    ...licenceOptions
                  ];
                }}
                loading={false}
                selectedValues={
                  internalRecord && internalRecord.licence
                    ? [
                        {
                          label: `${internalRecord.licence[0].toUpperCase()}${internalRecord.licence
                            .slice(1)
                            .toLowerCase()}`.replaceAll('_', ' '),
                          value: internalRecord.licence
                        }
                      ]
                    : [
                        {
                          value: null,
                          label: 'No license'
                        }
                      ]
                }
                customContainerStyle={styles.licenceDropdownContainer}
                fixedPosition
              />
            </div>
            {internalRecord && internalRecord.nextLicence ? (
              <div
                className={`${styles.dropdownContainer} ${
                  styles.dropdownLicenceContainer
                }`}
              >
                <div className={styles.subtitle}>New license</div>
                <Dropdown
                  customPlaceholder="Select licence"
                  onSelectCompleted={nextLicence =>
                    setInternalRecord({
                      ...internalRecord,
                      nextLicence: nextLicence.value
                    })
                  }
                  fetchOptions={() =>
                    Object.keys(licenceTypes).map(l => {
                      const capitalised = `${l[0].toUpperCase()}${l
                        .slice(1)
                        .toLowerCase()}`;
                      return {
                        value: l,
                        label: capitalised.replaceAll('_', ' ')
                      };
                    })
                  }
                  loading={false}
                  selectedValues={
                    internalRecord && internalRecord.nextLicence
                      ? [
                          {
                            label: `${internalRecord.nextLicence[0].toUpperCase()}${internalRecord.nextLicence
                              .slice(1)
                              .toLowerCase()}`.replaceAll('_', ' '),
                            value: internalRecord.nextLicence
                          }
                        ]
                      : []
                  }
                  customContainerStyle={styles.licenceDropdownContainer}
                  fixedPosition
                />
              </div>
            ) : null}
          </div>
          {internalRecord && internalRecord.licence && activePopup ? (
            <div className={styles.additionalOptionCheck}>
              <input
                type="checkbox"
                onChange={() => {
                  if (internalRecord.nextLicence) {
                    setInternalRecord({
                      ...internalRecord,
                      nextLicence: null
                    });
                  } else {
                    setInternalRecord({
                      ...internalRecord,
                      nextLicence: licenceTypes.UNLIMITED
                    });
                  }
                }}
                checked={internalRecord && internalRecord.nextLicence}
              />
              Automatically extend licence
            </div>
          ) : null}
          {internalRecord && internalRecord.licence ? (
            <div className={styles.numberInputRows}>
              <NumberInputRow
                label="Price customer paid for this license (in euros)"
                description={
                  showAdditionalBudget ? 'Not including additional budget' : ''
                }
                value={internalRecord.pricePaidForLicence || ''}
                onChange={newAllocatedValue => {
                  setInternalRecord({
                    ...internalRecord,
                    pricePaidForLicence: newAllocatedValue
                  });
                }}
                disabled={isEditing}
              />
              {showAdditionalBudget ? (
                <NumberInputRow
                  label="Additional budget (in euros)"
                  description="Budget for consultancy, difficult profiles, translations, unfair use, ..."
                  value={
                    internalRecord.creditsLeft
                      ? creditsToEuros(internalRecord.creditsLeft)
                      : ''
                  }
                  onChange={newAllocatedValue => {
                    const creditsValue = newAllocatedValue
                      ? eurosToCredits(newAllocatedValue)
                      : 0;

                    setInternalRecord({
                      ...internalRecord,
                      creditsLeft: creditsValue,
                      creditsAllocated: creditsValue
                    });
                  }}
                  disabled={isEditing}
                />
              ) : null}
            </div>
          ) : null}
        </>
      ) : null}

      {level === 2 && parentWithLicence ? (
        <>
          <div className={styles.additionalOptionCheck}>
            <input
              type="checkbox"
              onChange={() => {
                if (
                  internalRecord.creditsAllocated ||
                  internalRecord.creditsAllocated === 0
                ) {
                  setInternalRecord({
                    ...internalRecord,
                    creditsAllocated: null
                  });
                } else {
                  setInternalRecord({
                    ...internalRecord,
                    creditsAllocated: 0
                  });
                }
              }}
              checked={
                internalRecord &&
                internalRecord.creditsAllocated !== null &&
                internalRecord.creditsAllocated !== undefined
              }
            />
            Allocate budget to this specific initiative
          </div>
        </>
      ) : null}
      <CreditsManipulator
        level={level}
        label1={label1}
        internalRecord={internalRecord}
        setInternalRecord={setInternalRecord}
        activePopup={activePopup}
        parentWithLicence={parentWithLicence}
        isEditing={isEditing}
        showAdditionalBudget={showAdditionalBudget}
      />
      {activePopup ? (
        <>
          <div className={styles.subtitle}>{subtitle2}</div>
          <div className={styles.dropdownContainer}>
            <Dropdown
              customPlaceholder="Select client account(s)"
              onSelectCompleted={onSelectClientCompleted}
              searchEnabled
              fetchOptions={fetchClientOptions}
              loading={false}
              selectedValues={
                internalRecord && internalRecord.managers
                  ? internalRecord.managers
                  : []
              }
              labelField="email"
              valueField="id"
              fixedPosition
            />
          </div>
        </>
      ) : null}
      <div className={styles.subtitle}>{inviteText}</div>
      {!invitationLink ? (
        <div
          className={styles.copyLinkButton}
          role="presentation"
          onClick={async () => {
            const invitationRecord = invitationParent || internalRecord.id;

            const invitationToken = await getInvitationLink({
              variables: {
                record: invitationRecord,
                invitationType
              }
            });
            if (
              invitationToken &&
              invitationToken.data &&
              invitationToken.data.getInvitationLink &&
              invitationToken.data.getInvitationLink.link
            ) {
              setInvitationLink(invitationToken.data.getInvitationLink.link);
            }
          }}
        >
          <img src={linkIcon} alt="Link icon" className={styles.linkIcon} />
          Generate link
        </div>
      ) : null}
      {invitationLink ? (
        <div className={styles.invitationLinkContainer}>
          <input value={invitationLink || ''} onChange={() => {}} />
          {!linkCopied ? (
            <div
              role="presentation"
              className={styles.copyInputLink}
              onClick={() => {
                copyLinkToClipboard();
                setLinkCopied(true);
              }}
            >
              Copy link
            </div>
          ) : null}
          {linkCopied ? (
            <div className={styles.copiedInputLink}>Copied</div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
